import { FormControl, Typography, Box, Autocomplete, TextField } from "@mui/material";

const AutoCompleteDropdown = ({
  label,
  id,
  name,
  value,
  onChange,
  options,
  searchPlaceholder = "Search",
  ...props
}) => {
  const handleChange = (event, newValue) => {
    const valueToPass = typeof newValue === "object" ? newValue?.value : newValue;
    const syntheticEvent = {
      target: {
        name,
        value: valueToPass,
      },
    };
    onChange(syntheticEvent);
  };

  const getSelectedOption = () => {
    if (!value) return null;
    return options.find((option) =>
      typeof option === "object" ? option.value === value : option === value
    );
  };

  return (
    <Box sx={{ width: "100%", mb: 2.5 }}>
      <Typography
        component="label"
        htmlFor={id}
        sx={{
          display: "block",
          mb: 1,
          fontWeight: "bold",
          color: "#333",
        }}
      >
        {label}
      </Typography>
      <FormControl fullWidth>
        <Autocomplete
          id={id}
          size="small"
          options={options}
          value={getSelectedOption()}
          onChange={handleChange}
          getOptionLabel={(option) => {
            if (!option) return "";
            return typeof option === "object" ? option.label : option;
          }}
          isOptionEqualToValue={(option, selectedValue) => {
            if (!option || !selectedValue) return false;
            return typeof option === "object"
              ? option.value ===
                  (typeof selectedValue === "object" ? selectedValue.value : selectedValue)
              : option === selectedValue;
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              name={name}
              placeholder={searchPlaceholder}
              sx={{ fontSize: "16px" }}
            />
          )}
          {...props}
        />
      </FormControl>
    </Box>
  );
};

export default AutoCompleteDropdown;
